query (
  $email: String!
) {
  isCustomerMigrated(
    email: $email
  )
}
